import { render, staticRenderFns } from "./ImprovedSurvey.vue?vue&type=template&id=35782a55"
import script from "./ImprovedSurvey.vue?vue&type=script&lang=js"
export * from "./ImprovedSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports